import { fetchPortalMe } from '../../api/portalMe';
import { isPortalAdmin } from '../../lib/portalSession';
import { ROUTES } from '../../lib/routes';
import { navigate } from '../../router';

/**
 * 관리자 페이지 진입 시 호출. 캐시된 role 외에 `/api/auth/me`를 한 번 더 확인해
 * 클라이언트 변조 시 즉시 홈으로 돌려보낸다. (서버 API는 require_admin가 별도 보호)
 */
export async function ensureAdminOrLeave(): Promise<boolean> {
  if (!isPortalAdmin()) {
    navigate(ROUTES.homePublic);
    return false;
  }
  const r = await fetchPortalMe();
  if (!r.ok || r.data.role !== 'admin') {
    navigate(ROUTES.homePublic);
    return false;
  }
  return true;
}
